import { Button } from 'components/common';
import dayjs from 'dayjs';

interface ResumeSubscription {
  ends_at?: string;
  stripe_price?: string;
}

interface ResumePlatinumSubscriptionProps {
  onResume: (subscription: ResumeSubscription) => void;
  subscription: ResumeSubscription;
  user: {
    features: {
      has_brokerage?: boolean;
      has_free_platinum?: boolean;
    };
  };
}

const ResumePlatinumSubscription = ({ onResume, subscription, user }: ResumePlatinumSubscriptionProps) => {
  const { ends_at, stripe_price } = subscription;
  const endsAt = dayjs(ends_at).format('dddd, MMMM D, YYYY');
  const frequency = stripe_price === 'platinum-solo-monthly' ? 'monthly' : 'yearly';

  return (
    <div className="card" data-testid="subscriptions-resume-subscription-card">
      <div className="card-body">
        <h4 className="fw-bold">Resume Platinum Solo subscription</h4>
        {user.features.has_free_platinum ? (
          <div className="mb-3">
            You currently have access to Platinum features through your
            {user.features.has_brokerage ? ' team' : ' Finmo account'}. You should not resume this subscription unless
            you are planning to
            {user.features.has_brokerage ? ' leave your team' : ' disconnect your Finmo account'}.
          </div>
        ) : (
          <div className="mb-3">
            If you&apos;d like to keep your access to Platinum features and any add-ons, please resume your {frequency}{' '}
            subscription before <strong>{endsAt}</strong>.
          </div>
        )}
        <Button
          onClick={() => onResume(subscription)}
          testId="subscriptions-resume-subscription-card-button"
          text="bold"
          variant="primary-dark"
        >
          Resume Platinum Solo subscription
        </Button>
      </div>
    </div>
  );
};

export default ResumePlatinumSubscription;
